import React, { useState, useEffect } from 'react';
import Select from '../ui/Select';

const CenterSelector = ({ centers, onCenterChange }) => {
  const [selectedCenter, setSelectedCenter] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (centers && centers?.length > 0 && !selectedCenter) {
      setSelectedCenter(centers?.[0]?.value);
      onCenterChange?.(centers?.[0]?.value);
    }
  }, [centers, selectedCenter, onCenterChange]);

  const handleCenterChange = (value) => {
    setIsLoading(true);
    setSelectedCenter(value);
    onCenterChange?.(value);
    
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  };

  const centerOptions = centers?.map(center => ({
    value: center?.id || center?.value,
    label: center?.name || center?.label,
    description: center?.location
  })) || [];

  return (
    <Select
      label="Select Center"
      options={centerOptions}
      value={selectedCenter}
      onChange={handleCenterChange}
      loading={isLoading}
      searchable={centerOptions?.length > 5}
      placeholder="Choose a center"
    />
  );
};

export default CenterSelector;